import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { saveCustomerIdentity } from '../../utils/customerIdentity';
import './styles.css';

function formatCnpj(value) {
    const digits = value.replace(/\D/g, '').slice(0, 14);
    return digits
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
}

function Identificacao() {
    const history = useHistory();
    const [empresa, setEmpresa] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [saving, setSaving] = useState(false);

    async function handleSubmit(event) {
        event.preventDefault();
        const company = empresa.trim();
        const cnpjDigits = cnpj.replace(/\D/g, '');
        if (!company || cnpjDigits.length !== 14) {
            alert('Informe a razão social e um CNPJ válido.');
            return;
        }

        const subdominio = window.location.hostname.split('.')[0];
        setSaving(true);
        try {
            const response = await api.get(`clientes/${subdominio}`);
            const store = response?.data?.[0];
            if (!store?.id) throw new Error('Loja não encontrada');
            const identity = { empresa: company, cnpj: formatCnpj(cnpjDigits) };
            await api.post('clientes-menu', identity, { headers: { authorization: store.id } });
            saveCustomerIdentity({ ...identity, cliente_id: store.id });
            history.replace('/');
        } catch (error) {
            alert('Não foi possível registrar seus dados. Tente novamente.');
        } finally {
            setSaving(false);
        }
    }

    return (
        <main className="customerIdentity">
            <form onSubmit={handleSubmit}>
                <h1>Somente para Empresas</h1>
                <p>Não é necessário cadastro</p>
                <label htmlFor="customerCompany">Razão social</label>
                <input id="customerCompany" value={empresa} onChange={event => setEmpresa(event.target.value)} placeholder="Razão social" maxLength={150} required />
                <label htmlFor="customerCnpj">CNPJ</label>
                <input id="customerCnpj" value={cnpj} onChange={event => setCnpj(formatCnpj(event.target.value))} placeholder="00.000.000/0000-00" inputMode="numeric" required />
                <button type="submit" disabled={saving}>{saving ? 'Aguarde...' : 'Acessar cardápio'}</button>
            </form>
        </main>
    );
}

export default Identificacao;
